import React from 'react';
import { cn } from './cn';

// `value` is 0–100. With no value (or `indeterminate`) the bar loops, for work
// whose length is unknown.
function Progress({ className, value, indeterminate = false, variant, ...props }) {
  const clamped = Math.max(0, Math.min(100, Number(value) || 0));
  return (
    <div
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={indeterminate ? undefined : Math.round(clamped)}
      className={cn(
        'ui-progress',
        indeterminate && 'ui-progress--indeterminate',
        variant && `ui-progress--${variant}`,
        className,
      )}
      {...props}
    >
      <div className="ui-progress__indicator" style={indeterminate ? undefined : { width: `${clamped}%` }} />
    </div>
  );
}

export { Progress };
